<template> 
  <v-app id="inspire">
     <router-view></router-view> 
     <v-snackbar
      v-model="snackbarVisible"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      location="top"
    >
      {{ snackbarText }}
      <template v-slot:actions>
        <v-btn
          color="white"
          variant="text"
          @click="closeSnackbar"
        >
          关闭
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script setup>

  import { ref,markRaw, computed } from 'vue'
  import HomePage from './views/HomePage.vue';
  import LoginPage from './components/LoginPage.vue';
  import {useRouter} from 'vue-router'
  import { useStore } from 'vuex'

  const store = useStore()
  const snackbarVisible = computed({
    get: () => store.state.snackbar.visible,
    set: (val) => {
      if (!val) store.commit('snackbar/close')
    }
  })
  const snackbarText = computed(() => store.state.snackbar.text)
  const snackbarColor = computed(() => store.state.snackbar.color)
  const snackbarTimeout = computed(() => store.state.snackbar.timeout)

  const closeSnackbar = () => {
    store.commit('snackbar/close')
  }

  const currentComponent = ref(null)

  const switchComponent = (component) => {
    currentComponent.value = component
  }

  // 判断用户是否登录
  const access_token = localStorage.getItem('access_token')
  if (access_token) {
    currentComponent.value = markRaw(HomePage)
  } else {
    currentComponent.value = markRaw(LoginPage)
  }

  //这个通过控路由的方式，在路由上把关，看用户是否已经登录
  // const router = useRouter()

  // router.beforeEach((to, from, next) => {
  //   const access_token = localStorage.getItem('access_token')
  //   if (access_token) {
  //     next()
  //   } else {
  //     next('/login')
  //   }
  // })







  
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 00px;
}
</style>
